
import React from "react";

export default function PreviewDrawer({ open, onClose, onPost, preview }) {
  if (!open) return null;
  return (
    <div className="hm-preview-backdrop" onClick={onClose}>
      <div className="hm-preview-panel" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true">
        <div className="hm-preview-head">
          <div className={`chip t-${preview.type}`}>{String(preview.type).toUpperCase()}</div>
          {preview.parentLabel && <div className="hm-preview-attach">→ {preview.parentLabel}</div>}
        </div>
        <div className="hm-preview-body">
          <p className="hm-preview-text">{preview.text}</p>
          {preview.link && <a className="hm-preview-link" href={preview.link} target="_blank" rel="noreferrer">{preview.link}</a>}
          {typeof preview.confidence === "number" && <div className="hm-preview-conf">Confidence: {Math.round(preview.confidence)}%</div>}
        </div>
        <div className="hm-preview-actions">
          <button className="btn subtle" onClick={onClose}>Keep editing</button>
          <button className="btn primary" onClick={onPost}>Post</button>
        </div>
      </div>
    </div>
  );
}
